import AppErrorPage from "./AppErrorPage";

const ConnectionErrorPage = () => (
  <AppErrorPage message="Server connection error, please try again later." />
);

export default ConnectionErrorPage;